import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useMutation, gql } from "@apollo/client";
import { Calendar } from "lucide-react";
import { SectionHeader } from "./SectionHeader";

const ADD_BOOKING = gql`
  mutation AddBooking($odrnumber: Int!, $participant: Int!, $booking: AddBookingInput!) {
    addBooking(odrnumber: $odrnumber, participant: $participant, booking: $booking) {
      message
    }
  }
`;

export const AddBookingEntryForm = ({
  odrNumber,
  refetch,
  participantId,
  showHeader = true,
  onSuccess,
  onCancel
}: {
  odrNumber: string;
  refetch: () => void;
  participantId: string;
  showHeader?: boolean;
  onSuccess: () => void;
  onCancel: () => void;
}) => {
  const [formData, setFormData] = useState({
    bookingNumber: "",
    arrestDate: "",
    releaseDate: "",
  });

  const [addBooking, { loading }] = useMutation(ADD_BOOKING);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await addBooking({
        variables: {
          odrnumber: parseInt(odrNumber),
		  participant: parseInt(participantId),
          booking: {
            bookingNumber: formData.bookingNumber,
            arrestDate: formData.arrestDate,
            releaseDate: formData.releaseDate,
          },
        },
      });
      refetch();
      onSuccess();
    } catch (error) {
      console.error("Error adding booking:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {showHeader && (
        <SectionHeader
          icon={Calendar}
          title="New Booking"
          subtitle="Record booking details"
        />
      )}
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="bookingNumber">Booking Number</Label>
          <Input
            id="bookingNumber"
            name="bookingNumber"
            value={formData.bookingNumber}
            onChange={handleInputChange}
            maxLength={11}
            required
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="releaseDate">Release Date (projected)</Label>
          <Input
            type="date"
            id="releaseDate"
            name="releaseDate"
            value={formData.releaseDate}
            onChange={handleInputChange}
          />
        </div>
      </div>

      <div className="flex items-end justify-between space-x-2 mt-6 pt-4 border-t">
        <div className="space-y-2 w-1/3">
          <Label htmlFor="arrestDate">Booking Date</Label>
          <Input
            type="date"
            id="arrestDate"
            name="arrestDate"
            value={formData.arrestDate}
            onChange={handleInputChange}
            required
          />
        </div>

        <div className="flex space-x-2">
            <Button size="sm" type="submit" disabled={loading}>
            {loading ? "Saving..." : "Add Booking"}
            </Button>
            <Button size="sm" variant="outline" onClick={onCancel} type="button">
            Cancel
            </Button>
        </div>
      </div>
    </form>
  );
};
